import React, {useCallback, useContext} from 'react';
import Token from '@bonprix/pattern-library/templates/token/default';
import {Constants} from '../view-constants';
import Landmark from '@core/scripts/components/landmark-adapter';
import {articleOverviewStaticContext} from '../ArticleOverviewStatic.jsx';
import {removeSingleFilterFromParams, yieldToMain} from '../ArticleOverviewHelper';
import {Alert} from '@bonprix/design-system';
import {useDispatch, useSelector} from 'react-redux';
import {loadOn} from '../LoaderSlice.jsx';
import {selectContentAjaxCall} from '../AjaxCallSlice.jsx';
import {useChangeFilters} from '../hooks/use-change-filters.js';

export default function FilterTokens({filterTokens, shopIdFilterGroup}) {
    const {texts, shopId, currentSearchParams} = useContext(articleOverviewStaticContext);

    const noFilterHitsInChosenCategory = useSelector(selectContentAjaxCall).retainShopIdFilterOnly;

    const dispatch = useDispatch();

    const {resetFilters, setFilters} = useChangeFilters();

    const removeToken = useCallback(
        (identifier, value, isRange) => {
            const params = removeSingleFilterFromParams(identifier, value, isRange, currentSearchParams.current);
            setFilters(params);
        },
        [shopIdFilterGroup, setFilters],
    );

    const removeAllTokens = useCallback(() => {
        yieldToMain(() => dispatch(loadOn(true)));
        yieldToMain(() => {
            resetFilters();
            sendFilterDeselectionLandmark(
                Constants.LANDMARK_FILTER_DESELECTION_ALL,
                Constants.LANDMARK_FILTER_DESELECTION_ALL,
            );
        });
    }, [sendFilterDeselectionLandmark, resetFilters]);

    const removeSingleToken = useCallback(
        (identifier, value, trackingId, isRange) => {
            yieldToMain(() => dispatch(loadOn(true)));
            yieldToMain(() => {
                removeToken(identifier, value, isRange);
                sendFilterDeselectionLandmark(trackingId, Constants.LANDMARK_FILTER_DESELECTION_SINGLE);
            });
        },
        [sendFilterDeselectionLandmark, removeToken],
    );

    return (
        <div>
            {filterTokens.length > 0 ? (
                <div className="filter-tokens">
                    {filterTokens.map((token, index) => {
                        return renderToken(token, index);
                    })}
                    <span
                        className="filter-token__reset-button"
                        onClick={removeAllTokens}
                        test-ref__filter-token-reset-button=""
                    >
                        {texts.filter_reset}
                    </span>
                </div>
            ) : (
                <>
                    {noFilterHitsInChosenCategory && (
                        <div className="filter-tokens__alert">
                            <Alert
                                isOpen={true}
                                severity={'info'}
                                variant={'secondary'}
                                showCloseIcon={false}
                                title={texts.filter_removedByUnavailability}
                            >
                                <></>
                            </Alert>
                        </div>
                    )}
                </>
            )}
        </div>
    );

    function renderToken(token, index) {
        const handleClick = (event) => {
            event.preventDefault();
            removeSingleToken(token.filterIdentifier, token.filterOptionIdentifier, token.trackingId, token.isRange);
        };
        const filterName = `${token.filterOptionName}${token.isShowFilterName ? ` (${token.filterName})` : ''}`;

        return (
            <span test-ref__filter-token={token.filterName} key={index}>
                <Token filterName={filterName} onClick={handleClick} />
            </span>
        );
    }

    function sendFilterDeselectionLandmark(value, type) {
        const shopIdFormatted = shopId.current ? `${shopId.current}` : '0';

        let landmarkData = {
            filter_click: `${Constants.LANDMARK_FILTER_DESELECTION}|${value}|${type}|${Constants.LANDMARK_FILTER_POSITION}`,
            filter_click_shopId: `${shopIdFormatted}`,
            fixation: Constants.LANDMARK_NON_STICKY,
        };

        Landmark.sendLandmark({
            landmark: 'userinterface',
            ...landmarkData,
        });
    }
}
